var map = {
	"./aichi.png": "725c",
	"./akita.png": "1b2c",
	"./aomori.png": "13d2",
	"./chiba.png": "d9fd",
	"./ehime.png": "9bd2",
	"./fukui.png": "db90",
	"./fukuoka.png": "2a59",
	"./fukushima.png": "9ef3",
	"./gifu.png": "e3459",
	"./gunma.png": "b3b4",
	"./hiroshima.png": "f6a3",
	"./hokkaido.png": "02a9",
	"./hyogo.png": "75f3",
	"./ibaraki.png": "5b09",
	"./ishikawa.png": "81c8",
	"./iwate.png": "2ada",
	"./kagawa.png": "7e0e",
	"./kagoshima.png": "fc1f",
	"./kanagawa.png": "370d",
	"./kochi.png": "3ead",
	"./kumamoto.png": "ca68",
	"./kyoto.png": "69ab",
	"./meisyo_roulette_anime.gif": "d3f2",
	"./mie.png": "2987",
	"./miyagi.png": "e23f",
	"./miyazaki.png": "3258",
	"./nagano.png": "d3da",
	"./nagasaki.png": "b94d",
	"./nara.png": "d4e4",
	"./niigata.png": "757f",
	"./oita.png": "5fd6",
	"./okayama.png": "7695",
	"./okinawa.png": "c852",
	"./osaka.png": "af5c",
	"./saga.png": "c294",
	"./saitama.png": "a701",
	"./shiga.png": "2bf3",
	"./shimane.png": "ab19",
	"./shizuoka.png": "263b",
	"./tochigi.png": "1243",
	"./tokushima.png": "f36c",
	"./tokyo.png": "0c75",
	"./tottori.png": "595c",
	"./toyama.png": "d118",
	"./wakayama.png": "ec36",
	"./yamagata.png": "44fd",
	"./yamaguchi.png": "104a",
	"./yamanashi.png": "3f71"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ffed";